import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useQuery } from '@tanstack/react-query';

interface CrashGameDetailProps {
  detail: CrashLatestGameItem;
}

import { StyledTableWrapper } from '@/components/features/casino/crash/GameBox/CrashHistory/DetailModal/styles';
import { getPlayerTableColumn } from '@/components/features/casino/crash/PlayerBox';
import { formatMember } from '@/components/features/casino/crash/PlayerBox/useCrashMember';
import VirtualizedTable from '@/components/ui/WrappedTable/VirtualizedTable';
import { crashGameRanks, CrashLatestGameItem } from '@/apis/casino/crash';

const LeaderboardPanel: React.FC<CrashGameDetailProps> = ({ detail }) => {
  const { t } = useTranslation();
  const columns = getPlayerTableColumn(t);
  const theme = useTheme();

  const { data: ranks, isLoading } = useQuery({
    queryKey: ['crashGameRanks', detail.id, detail.roundId],
    queryFn: async () => {
      const res: any = await crashGameRanks({
        gameId: Number(detail.id),
        roundId: Number(detail.roundId),
      });
      if (res.status.code === '0') {
        return res.data.ranks.map((item) => formatMember(item));
      } else {
        return [];
      }
    },
  });
  return (
    <Box sx={{ mt: 3, backgroundColor: (theme) => theme.palette.grey[950] }}>
      <StyledTableWrapper>
        <VirtualizedTable
          loading={isLoading}
          data={ranks ? ranks : []}
          columns={columns}
          height={'338px'}
          bgcolor={theme.palette.grey[950]}
        />
      </StyledTableWrapper>
    </Box>
  );
};

export default LeaderboardPanel;
